import { translations as translationsFluereProcess } from '@sms/fluere-process-fluere-process-ui';
import { translations as translationsJournalTask } from '@sms/journal-task-journal-task-ui';
import { translations as translationsJournalEvent } from '@sms/journal-event-journal-event-ui';
import { translations as translationsJournalCep } from '@sms/journal-cep-journal-cep-ui';
import { translations as translationsReports } from '@sms/report-report-ui';
import { translations as translationsDecision } from '@sms/decision-table-decision-ui';
import { translations as translationsDashboard } from '@sms/dashboard-dashboard-ui';
import { translations as translationsCategory } from '@sms/category-category-ui'
import { translations as translationsJournalBook } from '@sms/journal-books-journal-books-ui'

import en_US from './en_US.json';
import pt_BR from './pt_BR.json';

export default {
  pt_BR: {
    ...translationsFluereProcess.pt_BR,
    ...translationsJournalTask.pt_BR,
    ...translationsJournalEvent.pt_BR,
    ...translationsJournalCep.pt_BR,
    ...translationsReports.pt_BR,
    ...translationsDecision.pt_BR,
    ...translationsDashboard.pt_BR,
    ...translationsCategory.pt_BR,
    ...translationsJournalBook.pt_BR,
    ...pt_BR,
  },
  en_US: {
    ...translationsFluereProcess.en_US,
    ...translationsJournalTask.en_US,
    ...translationsJournalEvent.en_US,
    ...translationsJournalCep.en_US,
    ...translationsReports.en_US,
    ...translationsDecision.en_US,
    ...translationsDashboard.en_US,
    ...translationsCategory.en_US,
    ...translationsJournalBook.en_US,
    ...en_US,
  },
};
